import { baConfig } from '../../config';

type TransactionsSvcConfig = Pick<typeof baConfig, 'gatewayUrl' | 'apiUrl'>;

/**
 * Base URL for the transactions read endpoints Transactions4 still calls by
 * path (`/orgs/{orgId}/lookups`, `/orgs/{orgId}/transactions`,
 * `/orgs/{orgId}/transactions/summary_v2`).
 *
 * Always the api-gateway. The legacy transactions-query-svc host
 * (https://transactions.bitwave.io, AlloyDB) was shut down on 2026-10-19
 * (transactions-materializer-svc !203); the gateway serves the same paths
 * from api-svc (Spanner) for every cluster, so there is no per-org
 * `multi-cluster-routing` gate here any more. Local dev has no gateway and
 * falls back to the api-svc URL, which serves the same paths directly.
 *
 * No trailing slash: call sites append `/orgs/...`.
 */
export function getTransactionsSvcBaseUrl(config: TransactionsSvcConfig = baConfig): string {
  const base = config.gatewayUrl || config.apiUrl || '';
  return base.replace(/\/+$/, '');
}
